// AboutUs.jsx
import '../pages/About.css';
import React, {useState,useEffect} from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import millImage from '../assets/Links/Mill.png'; // Adjust the path as necessary
import ScrollArrow from '../components/ScrollArrow';
import butlerLogo from '../assets/Links/Butler_Logo.png';
import paddy1 from '../assets/Links/Paddy_2.png';
import paddy2 from '../assets/Links/Paddy_1.png';
import icon1 from '../assets/Links/Icon1.png';
import icon2 from '../assets/Links/Icon2.png';
import icon3 from '../assets/Links/Icon3.png';  
import icon4 from '../assets/Links/Icon4.png';
import icon5 from '../assets/Links/Icon5.png';
import icon6 from '../assets/Links/Icon6.png';
import icon7 from '../assets/Links/Icon7.png';
import icon8 from '../assets/Links/Icon8.png';
import BackToTop from '../components/BackToTop';


const AboutUs = () => {
  const [showArrow, setShowArrow] = useState(true);
  const extraOffset = 50; // pixels to move further down
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setShowArrow(scrollY < 50); // show only at top
       const link = document.createElement('link');
           link.rel = 'preload';
    link.as = 'image';
    link.href = millImage; // correct hashed path after build
    document.head.appendChild(link);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);

       

  }, []);
  
    const scrollToNextSection = () => {
    window.scrollTo({
      top: window.innerHeight+ extraOffset,
      behavior: "smooth",
    });
  };
  return (
    <section className="page-wrapper">
        {/* <HeroBanner /> */}
        
      <div className='about-wrapper'>
        
        <img src={millImage} alt="Mill" className="about-bg"/>
         <div className="navbar-overlay">
        <NavBar />
      </div>
      <div className="about-content">
       
        <div className="butler-logo-container-about">
           <div className='empty'></div>
                  <img src={butlerLogo} alt="Butler Logo" />
                   <div className='empty'></div>
                </div>
                <div className='about-history'>
                  <div className='empty'></div>
        <div className='our-history'>
          <h1 className='accent-heading'>Our</h1>
          <h2 className='primary-heading'>History</h2>
          <p>Established in 2004, <span className='highlight'>Shrivel Hi-Tech Rice Industries</span> has grown to become one of the most trusted and rapidly expanding rice millers and marketers in <span className='highlight'>Tamil Nadu</span>. With a focus on sourcing only the finest paddy from rich agricultural belts and combining it with cutting-edge milling technology, we deliver rice that excels in quality, taste, and aroma.</p>
          <p>At Shrivel, we believe that true quality begins at the source. That’s why we have developed a rigorous, end-to-end procurement system that ensures every grain is <span className='highlight'>carefully selected, hygienically processed, and thoroughly quality-checked.</span> Our experienced team oversees each step—from procurement to packaging—with strict attention to detail, ensuring consistency and purity in every batch.</p>
          <p>Over the years, we’ve earned the trust of countless homes across Tamil Nadu and beyond. With every grain we produce, we aim to nourish families, celebrate traditions, and uphold our promise of excellence.</p>
          <p>ISO 9001: 2015 CERTIFIED | FSSAI Lic. No.: 12418027001138</p>
        </div>
        <div className='empty'></div>
        </div>
        <div className="why-choose-us">
          <div className="why-choose-us-brief">
            <div className='empty'></div>
            <div className="why-choose-us-text">
              <h1 className='accent-heading'>Why</h1>
              <h2 className='primary-heading'>Choose Us?</h2>
              <ul className='choose-list'>
                <li><span className='highlight'>Aged to Perfection </span>– Naturally matured for 1+ years for deeper taste and aroma</li>
                <li><span className='highlight'>Soft Yet Fluffy Texture </span>– Ideal for traditional South Indian cooking</li>
                <li><span className='highlight'>Preferred by Mothers  </span>– Ideal for traditional South Indian cooking</li>
                <li><span className='highlight'>Hygienically Processed </span>– Cleaned with care and sealed for freshness</li>
              </ul>
              </div>
              <div className='tagline'>
                <div className='tagline-text'>
                <p><span className='tag'>When mothers choose quality, they choose Mr.Butler.</span></p>
                <p>-The rice that turns every meal into a celebration</p>
                </div>
                </div>
            
            </div>
            <div className="why-choose-us-list">
  <img src={paddy1} alt="Left" className="side-image-about left-image-paddy" />

  <div className="grid-container">
    <div className="grid-item">
      <img src={icon1} alt="Mother's Choice" />
      <h3>Mother's Choice</h3>
      <p>Mothers trust us. Whether it's daily meals or festive feasts, our rice is a staple in kitchens that care about both health and flavor.</p>
    </div>
    <div className="grid-item">
      <img src={icon2} alt="Finest Pick" />
      <h3>Finest Pick</h3>
      <p>Only the best paddy makes the cut. Our grains are handpicked from fertile fields, ensuring every batch starts with the highest quality raw material.</p>
    </div>
    <div className="grid-item">
      <img src={icon3} alt="Hygienically Processed" />
      <h3>Hygienically Processed</h3>
      <p>Our rice goes through a fully automated, dust-free milling environment. Clean, safe, and untouched by hand—perfect for healthy cooking.</p>
    </div>
    <div className="grid-item">
      <img src={icon4} alt="Tradition Approved" />
      <h3>Tradition Approved</h3>
      <p>Each grain is inspected and tested at every stage. From field to pack, we never compromise on texture, taste, or purity.</p>
    </div>
    <div className="grid-item">
      <img src={icon5} alt="Long Grain, Lasting Impression" />
      <h3>Long Grain, Lasting Impression</h3>
      <p>Each grain is slender, polished, and naturally aged for non-sticky, fluffy rice that elevates every meal—from daily lunch to festive meals.</p>
    </div>
    <div className="grid-item">
      <img src={icon6} alt="Lingering Aroma" />
      <h3>Lingering Aroma</h3>
      <p>Experience the subtle yet enchanting aroma that gently fills your kitchen. A fragrance that invites hearts to the dining table before the first bite.</p>
    </div>
    <div className="grid-item">
      <img src={icon7} alt="Sweet Taste of Purity" />
      <h3>Sweet Taste of Purity</h3>
      <p>Mildly sweet, naturally pure, and refreshingly clean—our rice is the essence of homemade comfort and tradition in every bite.</p>
    </div>
    <div className="grid-item">
      <img src={icon8} alt="Old Rice, New Taste" />
      <h3>Old Rice, New Taste</h3>
      <p>Expertly aged rice that cooks with perfect fluff and aroma—ideal for biryani, pulao, or any dish that deserves a rich, full-bodied taste.</p>
    </div>
  </div>

  <img src={paddy2} alt="Right" className="side-image-about right-image-paddy" />
</div>

          </div>
        </div>
        </div>
         {showArrow && (
        <ScrollArrow onClick={scrollToNextSection} /> )}
         <BackToTop />
    <Footer/>
    </section>
  );
};

export default AboutUs;